// RBAC Manager class
class RbacManager {
  constructor(role, form, inWF = null, isOwner = false) {
    this.currentRole = role;
    this.currentForm = form;
    this.itemInWF = inWF;
    this.isUserOwner = isOwner;
  }
  static roleformfieldmap = {}

  // static roleformfieldmap = {
  //   [constants.ROLES.SUPER_ADMIN]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brand_logo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "company_logo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brand_logo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "company_logo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.ROLES.CUSTOMER_PRIMARY]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "selectBranch": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "favoriteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityController": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "iban": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "declarationName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "bankAccountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.ROLES.BRANCH_PRIMARY]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "selectBranch": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "favoriteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityController": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "iban": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "bankAccountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.SALES_EXECUTIVE]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnAddInvite": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicySHC": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sampleOrder": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sampleOrder": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.AREA_SALES_MANAGER]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "NAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "undefined": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnAddInvite": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "removeVideo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sampleOrder": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "undefined": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addProducts": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSendLink": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnVerify": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "OrderIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdAtCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "erpCustIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "erpOrderIdCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "TransactionIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.OPS_COORDINATOR]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "NAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "undefined": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicySHC": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "NAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "undefined": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.OPS_MANAGER]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "NAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "undefined": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "undefined": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "cityVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "zoneVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "entityVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "regionVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "streetVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pincodeVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumberVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "districtVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandLogoVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatNumberVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetterVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalIdVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameEnVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogoVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyTypeVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocationVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompanyVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankNameOtherVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameArVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEnVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificateVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerSourceVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "typeOfBusinessVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificateVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "declarationNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalAddressVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "confirmationDateVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmailVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumberVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmailVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "contractAgreementVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditApplicationVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryLocationsVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobileVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadMobileVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadNameVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocumentsVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryBusinessUnitVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmailVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmailVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "typeOfBusinessOtherVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationSignatureVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobileVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobileVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicenseNumberVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignationVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignationVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "acknowledgementSignatureVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignationVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignationVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "governmentRegistrationNumberVerified": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.PRODUCTION_MANAGER]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "undefined": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "undefined": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnInvoice": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deleteButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.FIELD_ENGINEER]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "status": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "checkout": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceDetails": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.MAINTENANCE_HEAD]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "status": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "checkout": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceDetails": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "VMCO": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "region": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "street": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "bankName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "district": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ibanNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nationalID": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "prePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditLimit": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "geolocation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessType": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "accountNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "companyNameLc": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "crCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatCertificate": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "baladeahLicense": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "brandNameArabic": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchApprove": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessTypeOther": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "nonTradingDocuments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financeHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "businessHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "primaryContactDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.MAINTENANCE_MANAGER]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportTable": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "status": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": true
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.MAINTENANCE_TECHNICIAN]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "issueNameCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "status": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "checkout": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customers": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenance": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "supportDetails": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "maintenanceDetails": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videos": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "videoPopup": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "attachments": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "commentIcon": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.DRIVER]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "status": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTransfer": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orders": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "checkout": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceDetails": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     }
  //   },

  //   [constants.DESIGNATIONS.BRANCH_ACCOUNTANT]: {
  //     "catalog": {
  //       "fields": {
  //         "search": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "goToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addToCart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "selectBranch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "favoriteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityController": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "supportContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintList": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "statusCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "errorState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueNameCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueTypeCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "loadingState": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "requestIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "toggleButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDateCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevelCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceTable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceContent": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderList": {
  //       "fields": {
  //         "action": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "status": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdAt": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "actionMenu": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSyncSO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyName": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "orderNumber": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersTable": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "ordersContent": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "paymentStatus": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "approvalButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ordersPagination": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "SidebarList": {
  //       "fields": {
  //         "Orders": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "Catalog": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Company": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "General": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Settings": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Dashboard": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTransfer": {
  //           "visible": true,
  //           "editable": true
  //         }
  //       }
  //     },
  //     "accessPages": {
  //       "fields": {
  //         "cart": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orders": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "reports": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "support": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "checkout": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenance": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "supportDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceDetails": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "supDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCloseTicket": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsAdd": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailAdd": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailAdd": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "custDetailsEdit": {
  //       "fields": {
  //         "COD": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "DAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "SHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "GMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "NAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "VMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "city": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "iban": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "zone": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branch": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "credit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "region": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "street": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pincode": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "district": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "FandOSync": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Price Plan": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankLetter": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "dulySigned": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ibanNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nationalID": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "prePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnApplyAll": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyLogo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "geolocation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "productsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnAddInvite": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "buildingName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriod": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCost": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "documentsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "interCompany": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "accountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameEn": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "companyNameLc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "crCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "advancePayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchBlock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSelectItems": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnUploadExcel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerSource": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "partialPayment": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatCertificate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "baladeahLicense": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "brandNameArabic": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditLimitVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodDar": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "declarationName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchUnblock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodGmtc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodNaqi": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "creditPeriodVmco": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "extremePeriodShc": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyDAR": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicySHC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "bankAccountNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessTypeOther": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "contactDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryLocations": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyGMTC": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyNAQI": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "pricingPolicyVMCO": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessDetailsTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "finalSubmissionTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "nonTradingDocuments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadEmail": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedToEntityWise": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnBranchSaveChanges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnDownloadCustomers": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadMobile": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "vatRegistrationNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financeHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "financialInformationTab": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "businessHeadSameAsPrimary": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerApprovalChecklist": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "primaryContactDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "purchasingHeadDesignation": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "isDeliveryChargesApplicable": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "Download terms & conditions and upload duly signed document": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "maintDetailEdit": {
  //       "fields": {
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videos": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "addVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnClose": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueType": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "assignedTo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "imagePopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "videoPopup": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "attachments": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeImage": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "removeVideo": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentPanel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "issueDetails": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "ticketStatus": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "urgencyLevel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "warrantyEndDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "maintenanceCharges": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "machineSerialNumber": {
  //           "visible": false,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "orderDetailEdit": {
  //       "fields": {
  //         "stock": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnPay": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "driver": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "entity": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "images": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSave": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "orderBy": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "category": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "products": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addImages": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnCancel": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deleteCol": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "branchName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnApprove": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInvoice": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "erpOrderId": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paidAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "addProducts": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnSendLink": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "commentIcon": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "createdDate": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderFooter": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "quantityCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sampleOrder": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "totalAmount": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "updatedDate": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnInventory": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "customerName": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "deleteButton": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "netAmountCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "orderDetails": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "productIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "unitPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "actionButtons": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "paymentMethod": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "pricingPolicy": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vehicleNumber": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "deliveryCharges": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "sugarTaxPriceCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "vatPercentageCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "paymentPercentage": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "reservationStatus": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "expectedDeliveryDate": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     },
  //     "BankTransactions": {
  //       "fields": {
  //         "btnAdd": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "BankTable": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "btnReject": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "btnSubmit": {
  //           "visible": false,
  //           "editable": false
  //         },
  //         "btnVerify": {
  //           "visible": true,
  //           "editable": true
  //         },
  //         "statusCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "OrderIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "BankContent": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "customerCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "searchInput": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "createdAtCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "erpCustIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "erpOrderIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "TransactionIdCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "transactionDateCol": {
  //           "visible": true,
  //           "editable": false
  //         },
  //         "amountTransferredCol": {
  //           "visible": true,
  //           "editable": false
  //         }
  //       }
  //     }
  //   }
  // };

  static async loadRbacConfig(userRole = null, token) {
    try {
      // Prepare the payload with roles array
      const payload = {
        roles: userRole ? [userRole] : [] // Send array of roles, empty array if no role specified
      };
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/rbac/getrbacbyroles`;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(payload),

      });

      if (!response.ok) {
        throw new Error(`Failed to load RBAC configuration: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      // Assuming the API returns data in format: { roleformfieldmap: {...} }
      if (data.data) {
        RbacManager.roleformfieldmap[data.data[0].role] = data.data[0].rbac;
        //return data.roleformfieldmap;
      } else {
        throw new Error('Invalid RBAC configuration format received from server');
      }
    } catch (error) {
      console.error('Error loading RBAC config:', error);
      throw error;
    }
  }
  // static async loadRbacConfig(userRole = null,token) {
  //   try {
  //     // Prepare the payload with roles array
  //     const payload = {
  //       roles: userRole ? [userRole] : [] // Send array of roles, empty array if no role specified
  //     };
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/rbac/getrbacbyroles`;
  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //          "Authorization": `Bearer ${token}`
  //       },
  //       body: JSON.stringify(payload),

  //     });

  //     if (!response.ok) {
  //       throw new Error(`Failed to load RBAC configuration: ${response.status} ${response.statusText}`);
  //     }

  //     const data = await response.json();

  //     // Assuming the API returns data in format: { roleformfieldmap: {...} }
  //     if (data.data) {
  //       RbacManager.roleformfieldmap[data.data[0].role] = data.data[0].rbac;
  //       //return data.roleformfieldmap;
  //     } else {
  //       throw new Error('Invalid RBAC configuration format received from server');
  //     }
  //   } catch (error) {
  //     console.error('Error loading RBAC config:', error);
  //     throw error;
  //   }
  // }
  static getRoles() {
    return Object.keys(RbacManager.roleformfieldmap);
  }

  static getForms(role) {
    return Object.keys(RbacManager.roleformfieldmap?.["admin"] || {});
  }

  getFieldPermissions(role, form) {
    return RbacManager.roleformfieldmap?.[role]?.[form]?.fields || {};
  }

  /**
   * Returns the access definition object for a given field.
   * @param {string} field - The field name (e.g., 'orderNumber', 'customer')
   * @returns {object|undefined} The access definition object or undefined if not found
   */
  getFieldAccess(field) {
    return RbacManager.roleformfieldmap?.[this.currentRole]?.[this.currentForm]
      ?.fields?.[field];
  }

  /**
   * Checks if a field is visible for the current role and form
   * @param {string} field - The field name
   * @returns {boolean} True if the field is visible, false otherwise
   */
  isV(field, approvalWF = false, fieldInWF = false) {
    //console.log(field)
    const access = this.getFieldAccess(field);
    return (
      (access == null ? true : access.visible) &&
      (approvalWF == true && fieldInWF == true
        ? true
        : approvalWF == true && fieldInWF == false
          ? false
          : true)
    );
  }

  /**
   * Checks if a field is editable for the current role and form
   * @param {string} field - The field name
   * @returns {boolean} True if the field is editable, false otherwise
   */
  // isE(field, approvalWF = false, fieldInWF = false) {
  //   //console.log(`~~~~~~~~*********Checking access for field: ${field} in form: ${this.currentForm} for role: ${this.currentRole}`);
  //   const access = this.getFieldAccess(field);
  //   //console.log(`~~~~~~~~*********Access for field: ${field} is ${JSON.stringify(access)}`);
  //   {console.log(access == null ? true : access.editable) && (this.itemInWF == null ? true : this.isUserOwner) && ((approvalWF == true && fieldInWF == true) ? true : (approvalWF == true && fieldInWF == false) ? false : true);}
  //   return (access == null ? true : access.editable) && (this.itemInWF == null ? true : this.isUserOwner) && ((approvalWF == true && fieldInWF == true) ? true : (approvalWF == true && fieldInWF == false) ? false : true);
  // }
  isE(field, approvalWF = false, fieldInWF = false) {
    const access = this.getFieldAccess(field);
    //console.log(`~~~~~~~~*********Access for field: ${field} is ${JSON.stringify(access)}`);
    return (
      (access == null ? true : access.editable) &&
      (this.itemInWF == null ? true : this.isUserOwner) &&
      (approvalWF == true && fieldInWF == true
        ? true
        : approvalWF == true && fieldInWF == false
          ? false
          : true)
    );
  }
}

// Example usage
// const rbacMgr = new RbacManager('admin', 'orderList');
// const isV = rbacMgr.isV.bind(rbacMgr);
// const isE = rbacMgr.isE.bind(rbacMgr);
// console.log(isV('orderNumber')); // true
// console.log(isE('orderNumber')); // true
// console.log(isV('customer')); // false
// console.log(isE('customer')); // true
// console.log(isV('date')); // true
// console.log(isE('date')); // false

export default RbacManager;
